// extracted by mini-css-extract-plugin
module.exports = {"container":"user-menu_container__1MFos","nameDropdown":"user-menu_nameDropdown__zUSd3","dropdown":"user-menu_dropdown__2AYF3"};